import { Card } from 'antd';
import { down } from 'styled-breakpoints';
import styled from 'styled-components';

export const LayerCard = styled(Card)`
  position: absolute;
  bottom: 50px;
  left: 0;
  background: ${({ theme }) => theme.colorBgContainer};
  box-shadow: ${({ theme }) => theme.boxShadowSecondary};

  width: 300px;
  max-width: 45vw;
  ${down('sm')} {
    max-width: 80vw;
  }

  h3 {
    margin-bottom: 0;
    line-height: 1;
  }

  &[hidden] {
    display: none;
  }
`;
